import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({ name: 'noCurrencyFormat' })
export class NoCurrencyFormatPipe implements PipeTransform {
    transform(
        value: string | number,
        currencyCode: string,
        digitsInfo?: string,
        locale: string = 'en-US',
        display: string | boolean = 'symbol-narrow'
    ): string | null {
        let result = new CurrencyPipe(locale).transform(value, currencyCode.toUpperCase(), display, digitsInfo, locale);

        if (result) {
            result = result.replace(/[^\d\s.,-]+/g, '');
        }
        return result;
    }
}
